import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import PendingConnectionDetails from '../components/PendingConnectionDetails'
import AjaxLoaderImg from '../components/AjaxLoaderImg'
import DataSource from '../DataSource'
import { mapServiceTypeToTitle } from '../constants'
import PendingDetails from '../components/PendingDetails'
import globals from '../globals'
import Button from "../elements/Button";

class PendingConnectionNewSim extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            activationStatus: '' // pending|complete|error
        }

        this.icons = {
            orderReceived: 'icon-order-received.svg',
            simDispatched: 'icon-sim-dispatched.svg',
            expectedActivation: 'icon-expected-activation-mobile.svg'
        }

        this.serviceDetails = [
            { title: 'Service no.', value: this.props.serviceDetails.serviceNo },
            { title: 'Service type', value: mapServiceTypeToTitle[this.props.serviceDetails.type] },
            { title: 'Plan name', value: this.props.serviceDetails.planName },
            { title: 'Data', value: this.props.serviceDetails.data }
        ]
    }

    activateService () {
        this.setState({ activationStatus: 'pending' }, () => {
            DataSource.postData(
                '/api/postActivateNewSim',
                { hspaService: parseInt(this.props.serviceDetails.simOrderId) },
                () => {
                    this.setState({ activationStatus: 'complete' })
                    globals.pushEvent('ActivateSimReplacement')
                },
                () => this.setState({ activationStatus: 'error' })
            )
        })
    }

    render () {
        const ActivateNow = () => {
            if (this.state.activationStatus === 'pending') {
                return <AjaxLoaderImg width='50px' />
            } else if (this.state.activationStatus === 'complete') {
                return <div className='py-3 bold'>Success! Your mobile activation is underway.</div>
            } else if (this.state.activationStatus === 'error') {
                return <div className='py-3 bold'>Oops! Something went wrong, please try again shortly.</div>
            } else {
                if (this.props.serviceDetails.isShipped && this.props.serviceDetails.canActivate) {
                    return <Button title='Activate now' action={this.activateService.bind(this)} />
                } else if (!this.props.serviceDetails.isShipped) {
                    return <div className='py-3'>Activation unavailable until SIM is dispatched.</div>
                } else {
                    return <div className='py-3'>Pending, activation will be available shortly.</div>
                }
            }
        }

        return (
            <div className='pending-connection module'>
                <Heading title='Activate my new mobile SIM' />
                <ModuleWithLoader isLoaded>
                    <div className='row mx-3 mt-3 p-3 p-md-4 bg-lightgrey no-gutters'>
                        <div className='col-12 d-flex justify-content-center text-center flex-wrap'>
                            <PendingDetails items={this.serviceDetails} />
                        </div>
                    </div>
                    <div className='row my-3'>
                        <div className='col-12 col-md-6 offset-md-6 d-flex justify-content-center align-items-center text-center px-4 px-lg-0'>
                            {this.props.serviceDetails.isActivated ? <div>Your mobile activation is underway.</div> : ActivateNow()}
                        </div>
                    </div>
                    {this.props.status.map((item, key) => {
                        return (
                            <PendingConnectionDetails
                                key={key}
                                type={item.type}
                                icon={`/images/pending-connections/${this.icons[item.type]}`}
                                title={item.title}
                                subTitle={item.subTitle}
                                date={item.date}
                                items={item.items}
                            />
                        )
                    })}
                </ModuleWithLoader>
            </div>
        )
    }
};

export default PendingConnectionNewSim



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnectionNewSim.js